import * as React from "react";

import styles from "./UserAvatar.module.css";

const GRADIENTS = [
  "linear-gradient(135deg,#0a84ff,#5e5ce6)",
  "linear-gradient(135deg,#e8630f,#f0a15a)",
  "linear-gradient(135deg,#2f9e2f,#7ac77a)",
  "linear-gradient(135deg,#5e5ce6,#b06ad6)",
  "linear-gradient(135deg,#ff9f0a,#ffc16b)",
  "linear-gradient(135deg,#12b0a0,#5ed2c6)",
];

function hashName(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) {
    h = ((h << 5) - h + name.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

export interface UserAvatarProps {
  name: string;
  size?: "sm" | "md" | "lg";
  index?: number;
  className?: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ name, size = "md", index, className }) => {
  const gradientIdx = index != null ? index : hashName(name);
  const gradient = GRADIENTS[gradientIdx % GRADIENTS.length];

  return (
    <span
      className={`${styles.avatar} ${styles[size]}${className ? ` ${className}` : ""}`}
      style={{ background: gradient }}
    >
      {initialsOf(name)}
    </span>
  );
};
